export const iconFontAwesomeScienceMicroscope = (
	<i className="fa-solid fa-microscope"></i>
);
